import { render } from "./MetaGroup.vue?vue&type=template&id=335d2881"
import script from "./MetaGroup.vue?vue&type=script&lang=js"
export * from "./MetaGroup.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Projects\\Code\\2021 09 29 LMT\\LoR_Master\\UI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__